const wsMessageType = {
    IDENTIFICATION: 'IDENTIFICATION',
    ORDER_UPDATE: 'ORDER_UPDATE',
    UNLOCK_BLAZON: 'UNLOCK_BLAZON',
    POINTS_UPDATE: 'POINTS_UPDATE'
}

export { wsMessageType }
